// removed by extract-text-webpack-plugin
module.exports = {"grid-figure":"_2uITJWqG60L9Cf6Mi2s4Kh","auth":"_3Op-1VCwFnDzzI1jHwWQhO","control-buttons":"_2UGMueGjkJ-kyr99pmnE4T"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/components/Auth.styl
// module id = 485
// module chunks = 0